import { StoreAction } from "../../@core/constants/action";

const initialState = {
  meetingList: [],
  reminderList: [],
  meetingHistoryList: [],
  filterReminderMeetingList: {
    page: 1,
    rowPerPage: 10,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case StoreAction.SET_REMINDER_DATA:
      return { ...state, reminderList: action.payload };
    case StoreAction.SET_MEETING_DATA:
      return { ...state, meetingList: action.payload };
    case StoreAction.GET_MEETING_HISTORY_DATA:
      return { ...state, meetingHistoryList: action.payload };
    case StoreAction.SET_MEETINGREMINDER_FILTER:
      return { ...state, filterReminderMeetingList: action.payload };

    default:
      return state;
  }
}
